import styled from 'styled-components'

export const ChangeLabel = styled.div`
  text-transform: capitalize;
`

export const Change = styled.div`
  display: flex;
  justify-content: flex-start;
  white-space: pre-wrap;
`

export const ChangeFrom = styled.div`
  flex: 1;
  margin-right: 1.25rem;
`

export const ChangeTo = styled.div`
  flex: 1;
  margin-left: 1.25rem;
`
